import { Github, Linkedin, Twitter, Mail, Heart } from 'lucide-react';
import { motion } from 'framer-motion';

export const Footer = () => {
  const socialLinks = [
    { icon: <Twitter className="w-5 h-5" />, href: '#', label: 'Twitter' },
    { icon: <Linkedin className="w-5 h-5" />, href: '#', label: 'LinkedIn' },
    { icon: <Github className="w-5 h-5" />, href: '#', label: 'Github' },
    { icon: <Mail className="w-5 h-5" />, href: 'mailto:aayush07300@gmail.com', label: 'Email' },
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="relative py-12 border-t border-white/5" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6">
        <div className="grid md:grid-cols-3 gap-12 mb-12">
          <div>
            <motion.div
              className="text-2xl font-black tracking-tight mb-4"
              whileHover={{ scale: 1.05 }}
            >
              <span className="bg-gradient-to-r from-white to-zinc-400 bg-clip-text text-transparent">
                NEXUS
              </span>
              <span className="text-[#007AFF] ml-1">•</span>
            </motion.div>
            <p className="text-zinc-400 text-sm leading-relaxed mb-4">
              We build websites that convert visitors into customers. Premium web design and development for growing businesses.
            </p>
            <div className="flex gap-3">
              {socialLinks.map((social, index) => (
                <motion.a
                  key={index}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  whileHover={{ scale: 1.1, y: -2 }}
                  className="w-10 h-10 rounded-full glass-card flex items-center justify-center text-zinc-400 hover:text-[#007AFF] hover:border-[#007AFF] transition-all cursor-hover"
                  data-testid={`footer-social-${social.label.toLowerCase()}`}
                >
                  {social.icon}
                </motion.a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Quick Links</h3>
            <ul className="space-y-2">
              {['Services', 'Portfolio', 'Why Us', 'Testimonials', 'Contact'].map((item) => (
                <li key={item}>
                  <button
                    onClick={() => scrollToSection(`#${item.toLowerCase().replace(' ', '-')}`
                      .replace('why-us', 'trust')
                      .replace('portfolio', 'portfolio'))}
                    className="text-zinc-400 hover:text-[#007AFF] transition-colors text-sm cursor-hover"
                    data-testid={`footer-link-${item.toLowerCase()}`}
                  >
                    {item}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h3 className="font-bold text-lg mb-4">Get In Touch</h3>
            <ul className="space-y-3 text-sm text-zinc-400">
              <li data-testid="footer-email">
                <a href="mailto:aayush07300@gmail.com" className="hover:text-[#007AFF] transition-colors cursor-hover">
                  aayush07300@gmail.com
                </a>
              </li>
              <li data-testid="footer-phone">
                <a href="tel:+919372214207" className="hover:text-[#007AFF] transition-colors cursor-hover">
                  +91 93722 14207
                </a>
              </li>
              <li data-testid="footer-location">Mumbai, Maharashtra, India</li>
            </ul>
          </div>
        </div>

        <div className="pt-8 border-t border-white/5">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-zinc-500">
            <p data-testid="footer-copyright">
              © {new Date().getFullYear()} Nexus Web Studio. All rights reserved.
            </p>
            <p className="flex items-center gap-2" data-testid="footer-credit">
              Built with <Heart className="w-4 h-4 text-[#007AFF] fill-[#007AFF]" /> by Nexus Team
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};